import { InjectionToken, Provider } from '@angular/core'

/**
 * Fetches the Firebase custom token this application signs into Firestore with.
 */
export type RealtimeTokenFetcher = () => Promise<string>

/**
 * Overrides where {@link RealtimeClient} gets its Firebase custom token.
 *
 * The token endpoint is per-API, not global: Fleet serves it from
 * `fleet/user/realtime-token`, and the TSP and TI applications talk to their own
 * APIs, where that route does not exist. Left unprovided, the client keeps its
 * historical Fleet behaviour.
 */
export const REALTIME_TOKEN_FETCHER = new InjectionToken<RealtimeTokenFetcher>(
  'RealtimeTokenFetcher',
)

/**
 * `factory` runs in an injection context, so it can `inject(ApiService)` and
 * return a closure over the route it needs:
 *
 *     provideRealtimeTokenFetcher(() => {
 *       const api = inject(ApiService)
 *       return () => api.ti.user.getRealtimeToken()
 *     })
 */
export const provideRealtimeTokenFetcher = (factory: () => RealtimeTokenFetcher): Provider[] => {
  return [{ provide: REALTIME_TOKEN_FETCHER, useFactory: factory }]
}
